var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommissionAndConversionMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35784 11.5674C10.1302 11.5674 11.5721 10.1254 11.5721 8.35308C11.5721 6.58076 10.1302 5.13879 8.35784 5.13879C6.58552 5.13879 5.14355 6.58076 5.14355 8.35308C5.14355 10.1254 6.58552 11.5674 8.35784 11.5674ZM8.35784 6.74594C9.244 6.74594 9.96498 7.46692 9.96498 8.35308C9.96498 9.23924 9.244 9.96022 8.35784 9.96022C7.47168 9.96022 6.7507 9.23924 6.7507 8.35308C6.7507 7.46692 7.47168 6.74594 8.35784 6.74594ZM17.6436 14.4245C15.8712 14.4245 14.4293 15.8665 14.4293 17.6388C14.4293 19.4111 15.8712 20.8531 17.6436 20.8531C19.4159 20.8531 20.8578 19.4111 20.8578 17.6388C20.8578 15.8665 19.4159 14.4245 17.6436 14.4245ZM17.6436 19.2459C16.7574 19.2459 16.0364 18.525 16.0364 17.6388C16.0364 16.7526 16.7574 16.0317 17.6436 16.0317C18.5297 16.0317 19.2507 16.7526 19.2507 17.6388C19.2507 18.525 18.5297 19.2459 17.6436 19.2459Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5303 6.46967C19.8232 6.76256 19.8232 7.23744 19.5303 7.53033L7.53033 19.5303C7.23744 19.8232 6.76256 19.8232 6.46967 19.5303C6.17678 19.2374 6.17678 18.7626 6.46967 18.4697L18.4697 6.46967C18.7626 6.17678 19.2374 6.17678 19.5303 6.46967Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionAndConversionMenuIcon);
export default __webpack_public_path__ + "static/media/commission-and-conversion-menu-icon.b86d23855a5a8e8b9fe2f8e7409ac1b7.svg";
export { ForwardRef as ReactComponent };